import React, { useState } from "react";
import {
  useTransition,
  useSpring,
  useChain,
  config,
  animated,
  useSpringRef,
} from "@react-spring/web";

import OpenWithIcon from "@mui/icons-material/OpenWith";

import data from "./data";

import { ItemsContainer } from "./styled";

import { AR, USA } from "./translation";

import img from "../Images/projects_images/1.jpg";

export default function Photos({ checkSaudiFlag, checkDarkMode }) {
  const [open, set] = useState(false);

  const springApi = useSpringRef();
  const { size, ...rest } = useSpring({
    ref: springApi,
    config: config.stiff,
    from: { size: "20%", background: "hotpink" },
    to: {
      size: open ? "100%" : "20%",
      background: open ? "white" : "hotpink",
    },
  });

  const transApi = useSpringRef();
  const transition = useTransition(open ? data : [], {
    ref: transApi,
    trail: 400 / data.length,
    from: { opacity: 0, scale: 0 },
    enter: { opacity: 1, scale: 1 },
    leave: { opacity: 0, scale: 0 },
  });

  // This will orchestrate the two animations above, comment the last arg and it creates a sequence
  useChain(open ? [springApi, transApi] : [transApi, springApi], [
    0,
    open ? 0.1 : 0.6,
  ]);

  return (
    <>
      <ItemsContainer
        open={open}
        className="wrapper"
        checkDarkMode={checkDarkMode}
        checkSaudiFlag={checkSaudiFlag}
      >
        <animated.div
          style={{ ...rest, width: size, height: size }}
          className="container"
          onClick={() => set((open) => !open)}
        >
          {transition((style, item) => (
            <animated.div
              className="item"
              style={{
                ...style,
                backgroundImage: `url(${item.css})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          ))}
          <div className="show-images-button">
            <div className="show-images-button-child">
              <span>
                {" "}
                {checkSaudiFlag ? AR.BTN : USA.BTN}{" "}
                <OpenWithIcon style={{ margin: "0 10px" }} />{" "}
              </span>
            </div>
          </div>
        </animated.div>
      </ItemsContainer>
    </>
  );
}
